import { Group } from 'src/design/atoms/Group';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import { Menu } from 'src/design/molecules/Menu';
import { IconDots, IconMessage } from '@tabler/icons-react';
import React from 'react';
import { DeleteActionIcon } from 'src/design/molecules/DeleteActionIcon';

interface IOptionMenuProps {
  onAddComment: () => void;
  onDeleteIssue: () => void;
}

export const OptionMenu: React.FC<IOptionMenuProps> = ({
  onAddComment,
  onDeleteIssue,
}) => {
  return (
    <Group gap="xs">
      <Menu>
        <Menu.Target>
          <BasicActionIcon variant="subtle" size="sm">
            <IconDots size={16} style={{ transform: 'rotate(90deg)' }} />
          </BasicActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            leftSection={<IconMessage size={16} />}
            onClick={onAddComment}
          >
            Add Comment
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
      <DeleteActionIcon
        requiredConfirmation={true}
        confirmationTitle="Delete Issue"
        confirmationText="Are you sure you want to delete this issue? This action cannot be reversed."
        onDelete={onDeleteIssue}
        size="sm"
      />
    </Group>
  );
};
